import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';

export default function ProgressChart({ data, height = 300 }) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 bg-gray-50 rounded-lg">
        <p className="text-gray-500">No assessment data available</p>
      </div>
    );
  }

  // Format data for chart
  const chartData = data.map((item) => ({
    name: item.name,
    date: new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    percentage: Math.round(item.percentage),
    fullDate: item.date,
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white shadow-lg rounded-lg p-3 border border-gray-200">
          <p className="font-medium text-gray-900">{payload[0].payload.name}</p>
          <p className="text-sm text-gray-500">{label}</p>
          <p className="text-lg font-bold text-indigo-600">{payload[0].value}%</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
        <XAxis
          dataKey="date"
          tick={{ fontSize: 12, fill: '#6B7280' }}
          tickLine={false}
        />
        <YAxis
          domain={[0, 100]}
          tick={{ fontSize: 12, fill: '#6B7280' }}
          tickLine={false}
          tickFormatter={(value) => `${value}%`}
        />
        <Tooltip content={<CustomTooltip />} />

        {/* Benchmark reference lines */}
        <ReferenceLine y={85} stroke="#10B981" strokeDasharray="5 5" label={{ value: 'Exceeding', fill: '#10B981', fontSize: 10 }} />
        <ReferenceLine y={70} stroke="#3B82F6" strokeDasharray="5 5" label={{ value: 'Meeting', fill: '#3B82F6', fontSize: 10 }} />
        <ReferenceLine y={50} stroke="#F59E0B" strokeDasharray="5 5" label={{ value: 'Approaching', fill: '#F59E0B', fontSize: 10 }} />

        <Line
          type="monotone"
          dataKey="percentage"
          stroke="#4F46E5"
          strokeWidth={2}
          dot={{ r: 6, fill: '#4F46E5', strokeWidth: 2, stroke: '#fff' }}
          activeDot={{ r: 8, fill: '#4F46E5' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
